import { api } from "./client";
import type { MeUser } from "@/shared/auth/store";

export interface LoginPayload { username: string; password: string }
export interface TokenPair    { access: string; refresh: string; user: MeUser }
export interface ChangePasswordPayload { current_password: string; new_password: string }

/**
 * 본인이 직접 고칠 수 있는 항목. 서버(`MeView.patch`)도 이 항목들만
 * 받는다 — 권한(role)·소속(organization)·배정 현장은 관리자만 바꾼다.
 *
 * `voice_lang` = 개인 음성경보 주 언어(AlertLang 문자열 하나). 백엔드에 아직
 * 필드가 없을 수 있으므로 호출부는 실패를 삼킨다(useVoiceLangSync 참조).
 */
export interface UpdateMePayload {
  email?: string;
  phone?: string;
  locale?: string;
  voice_lang?: string;
}

export const authApi = {
  login: (body: LoginPayload) =>
    api.post<TokenPair>("/auth/login", body).then((r) => r.data),

  me: () => api.get<MeUser>("/auth/me").then((r) => r.data),

  updateMe: (body: UpdateMePayload) =>
    api.patch<MeUser>("/auth/me", body).then((r) => r.data),

  logout: (refresh: string) =>
    api.post("/auth/logout", { refresh }).then(() => undefined),

  changePassword: (body: ChangePasswordPayload) =>
    api.post("/auth/change-password", body).then(() => undefined),
};
